import { Controller } from "stimulus"
export default class extends Controller {
  static targets = ["container", "yourSuggestion", "name", "placeId", "closeButton", "totalLikes", "id", "page",
                    "suggestButton", "likes", "types", "wishItemIndex", "wishItemId", "likeStatus", "form", "votes",
                    "placeName", "placeId", "addressLine", "likeButton", "userId", "modal", "beforeVote", "afterVote",
                    "loader"];

  connect() {
    const submitButton = document.querySelectorAll("#propagation-button")
    submitButton.forEach(button => {
      if(button){
        button.addEventListener("click", function(event){
          event.preventDefault();
          event.stopPropagation();
        })
      }
    });
  }
  
  async suggest() {
    const placeId = this.placeIdTarget.value;
    const types = this.typesTarget.value;
    const placeName = this.placeNameTarget.value;
    const addressLine = this.addressLineTarget.value;
    const userId = document.getElementById("user_id").value;
    
    const data = new FormData();
    data.append("user_id", userId);
    data.append("place_id", placeId);
    data.append("types", types);
    data.append("name", placeName);
    data.append("address_line", addressLine);

    const response = await fetch('/web/wish_items', {
      method: "POST",
      body: data,
    });
    const responseData = await response.json();
    const id = responseData.id;

    this.wishItemIdTarget.setAttribute("value", id);
    this.changeItem();
    this.close();
  }

  changeItem() {
    const likeButtonField = this.likeButtonTarget;
    const suggestedTextField = this.yourSuggestionTarget;
  
    suggestedTextField.classList.remove("hidden");
    const userId = parseInt(document.getElementById("user_id").value);
    likeButtonField.setAttribute(
      "data-action",
      userId === -1 ? "click->handler#requireAuth" : "click->wishlist#toggleLike"
    );
  
    this.changeIcon();
  }

  toggleLike(){
    this.debounce(this.likeDelay(), 1000)
  }

  async likeDelay(){
    this.changeIcon();
    const wishItem = this.wishItemIdTarget.parentElement;
    const id = parseInt(this.wishItemIdTarget.value);
    const page = this.pageTarget.value;

    const data = new FormData();
    data.append("id", id);
    data.append("page", page);

    const response = await fetch('/web/wish_items/toggle_like', {
      method: "POST",
      body: data,
    });

    const responseData = await response.json();

    if (responseData.status === "deleted" && page === "main") {
      wishItem.remove();
    }
  }

  changeIcon() {
    const { pageTarget, likeStatusTarget, totalLikesTarget } = this;
    const likeClassname = likeStatusTarget.classList.contains("fill") ? "disliked" : "liked";
    
    if (likeClassname === "disliked"){
      likeStatusTarget.className = `icons ${pageTarget.value === "main" ? "empty-gray mini" : "empty-red mini"} ${likeClassname}`;
    } else{
      likeStatusTarget.className = "icons fill liked";
    }
    this.changeLikeAmount(totalLikesTarget, likeClassname);
    this.changeLikeAnimation(likeStatusTarget, likeClassname);
  }

  changeLikeAnimation(likeIcon, likeStatus){
    setTimeout(()=>{
      likeIcon.classList.remove(likeStatus);
    }, 250)
  }

  changeLikeAmount(likesField, likeStatus) {
    const currentLikes = parseInt(likesField.getAttribute("value")) || 0;
    const newLikes = likeStatus === "liked" ? currentLikes + 1 : currentLikes - 1;
    likesField.setAttribute("value", newLikes);
    likesField.innerText = newLikes;
  }

  search() {
    const searchElement = document.getElementById("search");
    searchElement.blur();
    
    const loader = document.getElementById("loader");
    if (loader) {
      loader.classList.remove("hidden");
    }
  }

  close() {
    this.modalTarget.classList.add("hidden");
  }

  skip(){
    this.containerTarget.parentElement.remove();
  }
  
  open() {
    this.modalTarget.classList.remove("hidden");
  }

  async handleWishItem( {params} ) {
    this.beforeVoteTarget.classList.add("hidden");
    if (params.action === "vote") {
      this.afterVoteTarget.classList.remove("hidden");
      await new Promise(r => setTimeout(r, 3000));
    } else if (params.action === "skip") {
      this.loaderTarget.classList.remove("hidden");
      await new Promise(r => setTimeout(r, 500));
    }
  
    const id = this.idTarget.value;
    const data = new FormData();
    data.append("id", id);
  
    const endpoint = params.action === "vote" ? "/web/wish_items/vote" : "/web/wish_items/skip";
    const response = await fetch(endpoint, {
      method: "POST",
      body: data,
    });
  
    const responseData = await response.json();
  
    if (params.action === "vote") {
      this.updateSection(responseData, true);
    } else if (params.action === "skip") {
      this.updateSection(responseData);
    }
  }
  

  updateSection(data, isAfterVote = false) {
    const { id, name, likes, votes } = data;
    const isIdUndefined = id === undefined;
  
    this.containerTarget.classList.toggle("hidden", isIdUndefined);
    if (!isIdUndefined) {
      this.idTarget.value = id;
      this.nameTargets[0].innerText = name;
      this.nameTargets[1].innerText = name;
      this.likesTarget.innerText = likes;
      this.votesTarget.innerText = votes;
    }
  
    this.loaderTarget.classList.add("hidden");
    this.beforeVoteTarget.classList.remove("hidden");
    if (isAfterVote) {
      this.afterVoteTarget.classList.add("hidden");
    }
  }
  

  debounce(callee, timeoutMs) {
    return function perform(...args) {
      let previousCall = this.lastCall

      this.lastCall = Date.now()
      if (previousCall && this.lastCall - previousCall <= timeoutMs) {
        clearTimeout(this.lastCallTimer)
      }
      this.lastCallTimer = setTimeout(() => callee(...args), timeoutMs)
    }
  }

}